import { render } from "./InfoDocker.vue?vue&type=template&id=23cb3c81"
import script from "./InfoDocker.vue?vue&type=script&lang=js"
export * from "./InfoDocker.vue?vue&type=script&lang=js"

import "./InfoDocker.vue?vue&type=style&index=0&id=23cb3c81&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__